import React from 'react';
import { Carousel } from 'react-bootstrap';
import slide1 from '../img/image1.jpg';
import slide2 from '../img/imag2.jpg';
import slide3 from '../img/image3.jpg';
import '../style/Home.css'; 
import Image from '../components/Image.jsx'; 
import Travel from '../components/Travel.jsx';

const Home = () => {
  return (
    <div className='container1 '>
      <div className='row w-200'>
        <div className='col-sm-120'>
          {/* Carousel Section */}
          <Carousel interval={5000} fade>
            <Carousel.Item
              style={{
                height: '90vh',
                backgroundImage: `url(${slide1})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="content">
                <h1 className="animate__animated animate__fadeInDown">Welcome to Our Website</h1>
                <p className="animate__animated animate__fadeInUp animate__delay-1s">
                  Experience the power of modern design.
                </p>
              </div>
            </Carousel.Item>

            <Carousel.Item
              style={{
                height: '90vh',
                backgroundImage: `url(${slide2})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="content">
                <h1 className="animate__animated animate__fadeInDown">Explore Luxury Cars</h1>
                <p className="animate__animated animate__fadeInUp animate__delay-1s">
                  Discover the best in automotive design.
                </p>
              </div>
            </Carousel.Item>

            <Carousel.Item
              style={{
                height: '90vh',
                backgroundImage: `url(${slide3})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            >
              <div className="content">
                <h1 className="animate__animated animate__fadeInDown">Unleash the Speed</h1>
                <p className="animate__animated animate__fadeInUp animate__delay-1s">
                  Feel the thrill of performance cars.
                </p>
              </div>
            </Carousel.Item>
          </Carousel>

          {/* Cars Section */}
          <div>
            <h1 className="text-center mb-4 text-black">Our Latest Cars</h1>
            <div className="row g-4">
              <Image />
              {/* See More Cars Button */}
              <div className="text-center mt-4">
                <a href="/cars" className="btn btn-primary see-more-btn">See More Cars</a>
              </div>
            </div>
          </div>

          {/* Promotional Section */}
          <section className="py-5">
            <div className="row align-items-center">
              <div className="col-lg-2">
                <h2 className="display-5 fw-bold text-primary">100+</h2>
                <div>Vehicles & Tours</div>
              </div>
              <div className="col-lg-8 my-3 my-lg-0">
                <h2 className="display-5 fw-bold mb-2">Explore New Destinations with Us</h2>
                <p>Discover the best car rental options and tailor-made tours for your perfect adventure. Comfort, flexibility, and unforgettable experiences await you.</p>
              </div>
              <div className="col-lg-2 text-lg-end">
                <a className="btn btn-lg btn-primary" href="#">Book Your Tour Today</a>
              </div>
            </div>
            <Travel />
          </section>
        </div>
      </div>
    </div>
  );
};

export default Home;
